// src/pages/CareersPage.jsx
import React from 'react';
import Header from '../components/Header';
import Careers from '../components/Careers';
import Footer from '../components/Footer';
import '../assets/css/App.css';

const CareersPage = () => {
  return (
    <div className="App">
      <Header />
      <Careers showJobOpenings={true} /> {/* Show job openings on careers page */}
      <Footer />
    </div>
  );
};

export default CareersPage;